module.exports = __webpack_public_path__ + "img/cf_logo_padded.f5f60461.png";